import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteTrialModeAppAnnouncementBarMutationVariables = Types.Exact<{
  appAnnouncementBarId: Types.Scalars['Int']['input'];
}>;


export type DeleteTrialModeAppAnnouncementBarMutation = { __typename?: 'Mutation', deleteTrialModeAppAnnouncementBar: { __typename?: 'Payload', count: number, error?: Types.Error | null } };


export const DeleteTrialModeAppAnnouncementBarDocument = gql`
    mutation DeleteTrialModeAppAnnouncementBar($appAnnouncementBarId: Int!) {
  deleteTrialModeAppAnnouncementBar(appAnnouncementBarId: $appAnnouncementBarId) {
    count
    error
  }
}
    `;
export type DeleteTrialModeAppAnnouncementBarMutationFn = Apollo.MutationFunction<DeleteTrialModeAppAnnouncementBarMutation, DeleteTrialModeAppAnnouncementBarMutationVariables>;

/**
 * __useDeleteTrialModeAppAnnouncementBarMutation__
 *
 * To run a mutation, you first call `useDeleteTrialModeAppAnnouncementBarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrialModeAppAnnouncementBarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrialModeAppAnnouncementBarMutation, { data, loading, error }] = useDeleteTrialModeAppAnnouncementBarMutation({
 *   variables: {
 *      appAnnouncementBarId: // value for 'appAnnouncementBarId'
 *   },
 * });
 */
export function useDeleteTrialModeAppAnnouncementBarMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrialModeAppAnnouncementBarMutation, DeleteTrialModeAppAnnouncementBarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrialModeAppAnnouncementBarMutation, DeleteTrialModeAppAnnouncementBarMutationVariables>(DeleteTrialModeAppAnnouncementBarDocument, options);
      }
export type DeleteTrialModeAppAnnouncementBarMutationHookResult = ReturnType<typeof useDeleteTrialModeAppAnnouncementBarMutation>;
export type DeleteTrialModeAppAnnouncementBarMutationResult = Apollo.MutationResult<DeleteTrialModeAppAnnouncementBarMutation>;
export type DeleteTrialModeAppAnnouncementBarMutationOptions = Apollo.BaseMutationOptions<DeleteTrialModeAppAnnouncementBarMutation, DeleteTrialModeAppAnnouncementBarMutationVariables>;